import PageMeta from "../../components/common/PageMeta";
import DiningReqs from "../../components/hotel/DiningReqs";

export default function InRoomDining() {
    return (
        <>
        <PageMeta
            title="In-Room Dining Requests - SelfServe"
            description="SelfServe In-Room Dining Requests Dashboard"
        />
        <div className="col-span-12">
            <DiningReqs/>
        </div>
        </>
    );
}